<template>
  <div class="view--point">
    <loader v-if="loader"></loader>

    <header class="header">
      <div class="containter">
        <div class="row justify-content-center">
          <div class="col col-md-6 col-lg-4">
            <nav class="nav">
              <router-link :to="{ name: 'Points' }" tag="div" class="back"><i class="material-icons icon">chevron_left</i></router-link>
              <h1 class="title">{{ point.title }}</h1>
              <button
                class="send btn"
                v-on:click="toggleTransferPoint"
                v-if="point.transferEnable"
              >
                <i class="material-icons">redeem</i>
                {{ $t('points.transfer') }}
              </button>
              <div v-else class="placeholder"></div>
            </nav>
          </div>
        </div>
      </div>
    </header>

    <main v-cloak>
      <section class="point"
        v-if="point.type === 'POINT' || point.type === 'DEPOSIT'"
      >
        <div class="containter">
          <div class="row no-gutters justify-content-center">
            <div class="col col-md-6 col-lg-4">
              <span class="amount">{{ point.point| properNumber }}</span> {{ point.type === 'DEPOSIT' ? $tc("points.dollars", point.point) : $tc("points.points", point.point) }}
            </div>
          </div>
        </div>
      </section>
      <section>
        <div class="containter">
          <div class="row no-gutters justify-content-center">
            <div class="col col-md-6 col-lg-4">
              <point-item :point="point" />
              <powered-by></powered-by>
            </div>
          </div>
        </div>
      </section>
    </main>
    <point-transfer-modal
      :is-visible="pointTransfer"
      :max-amount="Number(point.point)"
      :default-country="'TW'"
      @cancel="handleCancelTransfer"
      @submit="handleTransferSubmit"
    />
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';

import swal from 'sweetalert2';
import Axios from '@/helpers/axios';

import Loader from '@/components/Loader.vue';
import PointItem from '@/components/PointItem.vue';
import PoweredBy from '@/components/PoweredBy.vue';
import pointTransferModal from '@/components/PointTransferModal.vue';

export default {
  name: 'Point',
  data() {
    return {
      pointTransfer: false,
    };
  },
  computed: {
    ...mapState([
      'brand',
      'client',
      'loader',
      'point',
    ]),
  },
  beforeMount() {
    if (this.brand.name === '') {
      this.$router.replace({ name: 'Points' });
    }

    this.emptyPoint();
    this.getPoint(this.$route.params.token);
  },
  methods: {
    ...mapMutations(['setLoader', 'emptyPoint']),
    ...mapActions(['getPoint']),
    toggleTransferPoint() {
      swal.fire({
        text: this.$i18n.t('points.transferReminderDescription'),
        confirmButtonText: this.$i18n.t('common.next'),
        showCancelButton: true,
        cancelButtonText: this.$i18n.t('common.cancel'),
        reverseButtons: true,
      }).then((send) => {
        if (send.value) {
          this.pointTransfer = true;
        }
      });
    },
    handleCancelTransfer() {
      this.pointTransfer = false;
    },
    async handleTransferSubmit(shareData, callback) {
      const data = {
        ...this.$route.query,
        lang: this.$i18n.locale,
        p: this.client.phoneType,
        dtk: this.client.dtk,
        _point_activity: this.point.token,
        ...shareData,
      };

      try {
        const response = await Axios({
          method: 'post',
          url: '/v2/Ocard/pointTransfer',
          data,
        });

        const { code, msg } = response.data;

        if (code === 500) {
          swal.fire({
            text: this.$i18n.t('points.transferSuccessfulDescription'),
            confirmButtonText: this.$i18n.t('common.ok'),
          }).then(() => {
            callback(true);
            window.location.reload();
          });
        } else {
          swal.fire({
            text: msg,
            confirmButtonText: this.$i18n.t('common.ok'),
          }).then(() => {
            callback(true);
            this.pointTransfer = false;
          });
        }
      } catch (e) {
        this.phoneError = '';
        this.member = '';
        callback(false);
      }
    },
  },
  components: {
    Loader,
    PointItem,
    PoweredBy,
    pointTransferModal,
  },
};
</script>

<style lang="sass" scoped>
$cb: cubic-bezier(.4, 0, .2, 1)

.view--coupon
  width: 100%
  height: 100%
  position: relative

  color: white

.header
  position: fixed
  top: 0
  right: 0
  left: 0
  padding: 12px
  z-index: 1020

  background-color: black

  color: white

  .back
    height: 24px
    float: left

    cursor: pointer

    .icon
      width: 36px
      height: 36px

      font-size: 2.25rem
      line-height: 1

  .title
    flex-grow: 1
    margin: 3px 0
    overflow: hidden

    font-size: 1.2081rem
    font-weight: bold
    text-align: center
    line-height: 28px
    white-space: nowrap
    text-overflow: ellipsis

  .placeholder
    width: 36px

  .btn
    padding: 0
    height: 34px
    background: transparent

    color: rgba(255, 255, 255, .75)

    vertical-align: middle
    line-height: 34px

    outline: 0

    &:active
      color: rgba(255, 255, 255, .25)

  .material-icons
    margin-right: 4px
    vertical-align: middle

main
  padding: 58px 0 80px

.point
  padding: 16px 0
  background-color: black

  text-align: center
  color: white
  font-size: 0.75rem
  font-weight: bold

  .amount
    margin-right: 2px
    display: inline-block

    font-size: 2.25rem
    font-weight: 300
    line-height: 36px

.point-share
  position: fixed
  top: 50%
  left: 50%
  width: 100%
  z-index: 1050
  opacity: 0

  transform: translate(-50%, -50%) scale(.75)
  transition: transform .25s $cb

  pointer-events: none

  &-overlay
    position: fixed
    right: 0
    bottom: 0
    left: 0
    top: 0
    z-index: 1040

    background-image: linear-gradient(0deg, rgba(44, 43, 43, 0.665) 0%, rgba(33, 32, 32, 0.665) 100%)

  &.active
    opacity: 1

    transform: translate(-50%, -50%)
    pointer-events: auto

  &__container
    overflow: hidden
    width: 100%

    border-radius: 16px

    background-color: #282828

    color: white

  .content
    padding: 24px 16px 16px

  &-text
    width: 100%
    padding: 16px

    border: none
    border-radius: 16px

    background-color: #333

    color: white

    &:focus
      outline: 0

  .form
    input[type=text],
    input[type=number],
    input[type=tel],
    input[type=password]
      width: 100%

      padding: 10px 15px

      border: none
      border-radius: 23px

      background-color: #eee

      font-weight: 700
      color: #333

      &:focus
        outline: none

    .readonly
      pointer-events: none

    .cell-country
      width: 100%
      padding: 10px 15px
      overflow: hidden

      border: none
      border-radius: 23px

      background-color: #ffea00
      background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEQAAAAwCAYAAACooNxlAAAABGdBTUEAALGPC/xhBQAAAYxJREFUaAXt1T9ugzAUBnAMQ5Zmh1vwZ2qToVvVC+Qulao26aWabjkBp4gEe3bo+9JYslCRYgPCSJ8lBwh5j+cfthMEbBSgAAUoQAEKUIACFKAABShAAQpQgAIUcBHIsuxd+qNLrBlTFMVW+pv53ZznkcvDZQBfSqm99F0cx6e6rs+OebZt235LntckSVRVVSeXPGPGWIPIrDjIAD5uRaxcUTAzbhgPyCV5nn1ACW11pfC2E7MOw/DHZvmkaboxMTr5Zr20niGY1niTeKNG5XfPFGAI4FHirzND5xCgQ1mWe30919EaBIW6ogAjiiLsGWtzwL5goCYnEATaomgMCfUWA+NyBkHwvSiC8SQz4yghXmNgTAofQ1ue5/gL/uzkuTRN8yLLQS0FA/WPAoJEfSi4J837mfFX5sAlo5Pg2Ld85NbK/J1PG6hZlz4ftIfoJPrYg6JvB75joNBRQZCwD2UJGJOA/IeyFAzUPmnDRos+6UOYnAIUoAAFKEABClCAAhSgAAUoQAEKUGCQwC/1HLKALR1EkwAAAABJRU5ErkJggg==')
      background-size: 24px
      background-repeat: no-repeat
      background-position: right center

      font-weight: 700
      color: #333

      -webkit-padding-end: 24px
      appearance: none
      text-overflow: ellipsis
      white-space: nowrap

      &__container
        height: 44px

        border-radius: 23px 0 0 23px

        background-color: #333

      &::after
        content: ''

      &:focus
        outline: none

    .cell[type=tel]
      border-radius: 0 23px 23px 0

      background-color: #333

      color: white

    .amount[type=number]
      border-radius: 23px
      background-color: #333
      color: white
      margin-top: 10px

  .btn
    position: relative
    margin-top: 24px
    padding: 8px 15px

    border-color: transparent
    border-radius: 99px

    background-color: #FFEA00

    font-size: 1.125em
    font-weight: 700
    color: #333

    outline: none
    appearance: none

    &:hover,
    &:active
      opacity: .5

      border-color: transparent

      background-color: #FFEA00

      color: #333

      outline: none

    &-secondary
      opacity: .5

    &.btn-loading
      pointer-events: none

      .btn-loader
        display: block

    .btn-loader
      position: absolute
      top: 0
      right: 0
      bottom: 0
      left: 0
      border-radius: 99px
      display: none

      background-color: inherit

      &.inverse
        span
          background-color: white

      span
        display: inline-block
        width: 10px
        height: 10px
        border-radius: 100%
        background-color: #575757
        margin: 18px 5px
        opacity: 0

        &:nth-child(1)
          animation: opacitychange .5s ease-in-out infinite

        &:nth-child(2)
          animation: opacitychange .5s ease-in-out .166666667s infinite

        &:nth-child(3)
          animation: opacitychange .5s ease-in-out .333333334s infinite

        @keyframes opacitychange
          0%, 100%
            opacity: 0

          60%
            opacity: 1
</style>
